export * as image1 from './image1.jpg'
export * as image2 from './image2.jpg'
export * as image3 from './image3.jpg'
export * as image4 from './image4.jpg'
